var _a;
import { createScopedInstanceAndLoader, getLanguage } from '@citrite/translate';
import { getVerticalSkin, VerticalSkin } from './verticalSkins';
const instance = createScopedInstanceAndLoader({
    namespace: 'projects-pilet',
    localesLoaderMap: {
        de: () => import('./locales/de.json'),
        en: () => import('./locales/en.json'),
        es: () => import('./locales/es.json'),
        fr: () => import('./locales/fr.json'),
        it: () => import('./locales/it.json'),
        ja: () => import('./locales/ja.json'),
        nl: () => import('./locales/nl.json'),
        'pt-BR': () => import('./locales/pt-BR.json'),
    },
    compatibilityJSON: 'v4',
});
(_a = instance.scopedi18nInstance.services.formatter) === null || _a === void 0 ? void 0 : _a.add('lower', (value) => {
    return value.toLocaleLowerCase();
});
export const { LocalizationLoader } = instance;
export { getLanguage };
export const t = (key, options) => instance.t(key, (options === null || options === void 0 ? void 0 : options.context) ? options : Object.assign({ context: getVerticalSkin() }, options));
export const ProjectsTitleStrings = new Map([
    [
        VerticalSkin.Default,
        new Map([
            ['de', 'Projekte'],
            ['en', 'Projects'],
            ['es', 'Proyectos'],
            ['fr', 'Projets'],
            ['it', 'Progetti'],
            ['ja', 'プロジェクト'],
            ['nl', 'Projecten'],
            ['pt-BR', 'Projetos'],
        ]),
    ],
]);
//# sourceMappingURL=translate.js.map